/** Shared slab heights; this leaf module must not import precinct plans or builders. */
export const CLOISTER_FLOOR = { walk: 0.08, garden: 0.12 } as const;
